/* 🤖 this file was generated by svg-to-ts */
export const matIconAirlines: {
  name: 'airlines';
  data: string;
} = {
  name: 'airlines',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.34 18H5.8l8.25-12h5.54l-2.25 12zM13 4 2 20h17l3-16h-9zm1.5 5a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>`
};
